









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Errors extends Vue {
    @Prop() errors!: String[];
}
